// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-audiotest-js": () => import("./../../../src/pages/audiotest.js" /* webpackChunkName: "component---src-pages-audiotest-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

